<app-service-detail>
    <app-variables-tabs primarySelectedTab="CrossTables" class="container-fluid px-5">
    </app-variables-tabs>
    <div class="col-12 pl-md-5 ml-auto list-header">

        <h1 class="list-header-title">
            {{'Form Fields / Registrations' | translate}}
            <span (click)="switchHeadings()"
                  class="addBtn services-icon--add ml-2"
                  style="position:relative;top:-5px;">Turn Table</span>
        </h1>
    </div>
    <div class="col-12 pl-5">
        <div class="row">
            <div class="col-md-12">
                <section class="table-container cross-table-container">
                    <section class="table-flip-scroll">
                        <table *ngIf="formFieldRegistrationRelations.length"
                        class="table table-bordered table-striped cross-table fields-regs">
                            <thead>
                                <tr>
                                    <th>{{'crosstables.form_field' | translate}}</th>
                                    <th *ngFor="let item of formFieldRegistrationRelations[0];">
                                        <span *ngIf="!tableSwitched"
                                              class="limited" title="{{ item.registrationName}}">
                                            {{ item.registrationShortName && item.registrationShortName !== "" ? item.registrationShortName : item.registrationName}}
                                        </span>
                                        <span *ngIf="tableSwitched">
                                            {{item.formFieldLabel}} ({{item.formLabel}})
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <fields-group 
                                *ngFor="let group of formFieldsGroup;"
                                [group]="group"
                                [registrations]="formFieldRegistrationRelations[0]"
                                (onRelationChange)="editFieldRegistrationEvent($event, null)"
                                (onToggleGroup)="toggleGroup($event)"></fields-group>
                            </tbody>
                        </table>
                    </section>
                </section>
            </div>
        </div>
    </div>
</app-service-detail>